import { Calendar, DatePicker } from 'v-calendar'
import 'v-calendar/style.css'

export default {
	install(app) {
		// 데이터피커(캘린더)
		app.component('VCalendar', Calendar)
		app.component('VDatePicker', DatePicker)
	},
};
